import axios, { buildApi } from '@/libs/api.request';
let name = ''

export const apis = buildApi({
  get: ['/shipments/export/statusList&list',],
  post: ['/shipments/export/statusExport']
})